<header
  #mainHeader
  class="mainHeader"
  [ngClass]="{
    withBanner: hasBanner
  }"
>
  <div class="mainHeader__mainLine" (mouseenter)="closeMenuLevel3_onDesktop()">
    <div class="mainLine__innerWrapper">
      <div *ngIf="isMdUp" class="mainHeader__searchbar mainHeader__searchbar--desktop" [class.active]="isSearchActive">
        <vc-searchbar (searchActive)="activeSearchClass($event)" (closeSearch)="closeMobileMainMenu()"></vc-searchbar>
      </div>
      <!-- search -->
      <div class="accessBuy accessItem vc-d-lg-none" (click)="bindMenuForMobile()">
        <button class="accessItem__icon" aria-labelledby="accessItem__item__title__buy">
          <span class="visuallyhidden" id="accessItem__item__title__buy" i18n="@@HEADER.NAVIGATION.BUY_TITLE">Buy</span>
          <vc-sprite-icons class="accessItem__icon__svg" name="menu-search"></vc-sprite-icons>
        </button>
      </div>

      <!-- title/logo -->
      <a class="mainHeader__logo" routerLink="">
        <img
          src="/assets/img/home/vestiairecollective_logo.svg?v=1"
          i18n-alt="@@SEO.LOGO_ALT"
          alt="Pre-owned fashion shop - Vestiaire Collective"
        />
      </a>

      <!-- cart -->
      <div class="mainLine__subNav">
        <div
          class="accessCart accessItem accessItem__cart mainHeader__mobile"
          [ngClass]="{'accessItem--active': isCartPreviewOpened}"
        >
          <button class="accessItem__icon" aria-labelledby="accessCart__icon__title__basket" (click)="cartAction()">
            <span
              class="accessCart__count icon__count"
              *ngIf="
                headerBadgeDetail && headerBadgeDetail?.orderLineCount && headerBadgeDetail?.orderLineCount <= 99;
                else orderLineCountMore
              "
            >
              {{ headerBadgeDetail?.orderLineCount }}
            </span>
            <ng-template #orderLineCountMore
              ><span class="accessCart__count" *ngIf="headerBadgeDetail && headerBadgeDetail?.orderLineCount">99+</span>
            </ng-template>
            <vc-sprite-icons class="accessItem__icon__svg" name="bag"></vc-sprite-icons>
          </button>
          <span
            class="accessItem__icon__title"
            id="accessCart__icon__title__basket"
            i18n="@@HEADER.NAVIGATION.CART_TITLE"
            >Basket</span
          >
          <vc-preview-box
            (resetBox)="closeBoxes($event)"
            i18n-title="@@HEADER.NAVIGATION.CART_TITLE"
            title="Basket"
            [isActive]="isCartPreviewOpened"
            [right_pos]="previewBox__cart_right_pos"
            id="previewBox__cart"
          >
            <vc-floating-cart [isShow]="isCartPreviewOpened"></vc-floating-cart>
          </vc-preview-box>
        </div>
      </div>
    </div>
  </div>

  <div class="mainHeader__secondLine" [ngClass]="{opened: isMainNavOpenedOnMobile}">
    <div class="secondLine__innerWrapper">
      <div class="mainHeader__mobileNav__header vc-d-lg-none">
        <img
          class="svg_logo_vestiaire_collective vc-d-md-none"
          alt="vestiairecollective"
          src="/assets/img/home/vestiairecollective_logo.svg?v=1"
        />
        <span class="mainHeader__mobileNav__close" (click)="closeMobileMainMenu()"></span>
      </div>
      <vc-main-nav
        class="mainHeader__mobileCategories"
        (closeMenuMobileEvent)="closeMobileMainMenu()"
        [directShippingEligible]="directShippingEligible"
        #nav
      ></vc-main-nav>
      <div class="mainHeader__searchbar" [class.active]="isSearchActive">
        <vc-searchbar (searchActive)="activeSearchClass($event)" (closeSearch)="closeMobileMainMenu()"></vc-searchbar>
      </div>
    </div>
  </div>
</header>

<!-- separated mobile navigation -->
<vc-user-accesses
  class="userAccess"
  [ngClass]="{hidden: isMainNavOpenedOnMobile || isCartPreviewOpened}"
  [isLogged]="isLogged"
  [userInfo]="userInfo$"
  [userWallet]="userWallet"
  [headerBadgeDetail]="headerBadgeDetail"
  [needGetPaidAction]="needGetPaidAction"
  (openMainNav)="bindMenuForMobile()"
></vc-user-accesses>
